<div class="margin-top mr-3">
  <h3 >{{ 'acercaDeTitulos1' | translate }}</h3> 
  <br>
  <pre class="text-justify"  [hidden]="isCurrentLang('es')">{{about.english}} </pre>
  <pre class="text-justify"  [hidden]="isCurrentLang('en')">{{about.spanish}} </pre>
</div>
